import React, { useEffect, useState } from "react";
import RenderSets from "features/set/components/Sets";
import SortContext from "context/SortContext";
import { useGlobalContext } from "context/GlobalContext";
import { useLocation, useNavigate } from "react-router-dom";
import { useRemoveDesings } from "features/set/hooks/useRemoveDesigns";
import { usePermissions } from "context/PermissionsContext";
import { findSpecificMenu, findSpecificPage, findSpecificSubMenu, findSpecificSubPage, hasAccessPage, hasAccessSubPage, isAllowed } from "utils/checkUserRigths";
import { useFilter } from "context/FilterContext";
import apiClient from "lib/api-client";
import { useQuery } from "@tanstack/react-query";

const Sets = () => {
  const { setSortOptions, setSelectedSortValue, setIsEdit, isEdit, setSearch, selectedSortValue, sortOptions } = React.useContext(SortContext);
  const { setCreateBtn, setCreateBtnName, setCreateBtnOption, setSearchPlaceHolder } = useGlobalContext();
  const { filterValues, setIsSetFilter, setFilterValues, setBackendFilterValues, setFilterCount, setAppliedFilterValues } = useFilter();
  const location = useLocation();
  const navigate = useNavigate();
  const innerChnages = location?.state?.innerChnages;

  useEffect(() => {
    if (location.state?.innerChnages) return;
    const params = new URLSearchParams(window.location.search);
    const encoded = params.get("crmState");
    if (!encoded) return;
    try {
      const crmState = JSON.parse(atob(encoded));
      navigate("/Sets", { replace: true, state: crmState });
    } catch (_) {}
  }, []);

  const { handleCancel: UIUpdate } = useRemoveDesings();

  const permissions = usePermissions();

  // const setCreateAccess = hasAccessPage(findSpecificPage("Sets", permission), "add");
  // const collectionViewAccess = hasAccessPage(findSpecificPage("Collection", permissions), "view");
  // const categoryViewAccess = hasAccessPage(findSpecificPage("Category", permissions), "view");
  // const setEditAccess = hasAccessPage(findSpecificPage("Sets", permissions), "edit");

  // const hasAccessToSeeSales = hasAccessSubPage(findSpecificSubPage(findSpecificPage("Settings", permissions), "Sales"), "view");
  // const hasAccessToSeeSales = hasAccessPage(findSpecificPage("Sales Count", permission), "view");

  const setCreateAccess = isAllowed(findSpecificSubMenu(findSpecificMenu("Vision Web", permissions), "Sets Access"), "create");
  const collectionViewAccess = isAllowed(findSpecificSubMenu(findSpecificMenu("Vision Web", permissions), "Collection Access"), "view");
  const categoryViewAccess = isAllowed(findSpecificSubMenu(findSpecificMenu("Vision Web", permissions), "Category Access"), "view");
  useEffect(() => {
    sessionStorage.setItem("appliedSortValue", selectedSortValue);
  }, [selectedSortValue, sortOptions]);

  useEffect(() => {
    setSortOptions([
      { id: 1, name: "Set No. (Low to High)", sortBy: "Set Date", order: "asc" },
      { id: 2, name: "Set No. (High to Low)", sortBy: "Set Date", order: "desc" },

      { id: 3, name: "Design Pieces (Low to High)", sortBy: "Number of Styles", order: "asc" },
      { id: 4, name: "Design Pieces (High to Low)", sortBy: "Number of Styles", order: "desc" },

      // { id: 5, name: "Set Date (Oldest to Newest)", sortBy: "Set Date", order: "asc" },
      // { id: 6, name: "Set Date (Newest to Oldest)", sortBy: "Set Date", order: "desc" },

      { id: 7, name: "Gold Net Weight (Low to High)", sortBy: "Gold Weight", order: "asc" },
      { id: 8, name: "Gold Net Weight (High to Low)", sortBy: "Gold Weight", order: "desc" },

      { id: 9, name: "Diamond Weight (Low to High)", sortBy: "Diamond Weight", order: "asc" },
      { id: 10, name: " Diamond Weight (High to Low)", sortBy: "Diamond Weight", order: "desc" },

      { id: 11, name: "Sales (Low to High)", sortBy: "Sales", order: "asc", access: true },
      { id: 12, name: "Sales (High to Low)", sortBy: "Sales", order: "desc", access: true },

      // { id: 13, name: "Latest Created Time ", sortBy: "Set Date", order: "desc" },
      { id: 14, name: "Latest Modified Time ", sortBy: "Latest Modified", order: "desc" },
    ]);

    setIsSetFilter(true);
    setSearchPlaceHolder("Search By Set or Design Number");
    //for create set btn
    if (!innerChnages) {
      setCreateBtn(setCreateAccess);
      setCreateBtnName("Create Set");
      setCreateBtnOption([
        { option: "By Category", link: "/Category", view: categoryViewAccess },
        { option: "By Collection", link: "/Collection", view: collectionViewAccess },
      ]);
      return () => {
        const goingToDesign = localStorage.getItem("navigatingToDesignPage") === "true";
        setCreateBtn(false);
        setCreateBtnName("");
        setCreateBtnOption([]);

        setIsSetFilter(false);
      };
    }

    return () => {
      //for create set btn
      setSearchPlaceHolder("Search");
      setSortOptions([]);
      setSelectedSortValue(null);
      setIsSetFilter(false);
      setFilterCount(0);
      sessionStorage.setItem("filterChangeCount", 0);
      setAppliedFilterValues({});
    };
  }, [innerChnages, isEdit, permissions]);

  useEffect(() => {
    //for edit view
    if (isEdit === "click") {
      setSortOptions([]);
      setSelectedSortValue(null);
      setCreateBtn(false);
      setCreateBtnName("");
      setCreateBtnOption([]);
      setIsEdit("click");
      // setFilterValues({});
      setIsSetFilter(false);
    } else {
      if (innerChnages) {
        setIsEdit("");
      } else {
        // setIsEdit("view");
        // setIsEdit(setEditAccess ? "view" : "");
        setIsEdit("archive");
      }
    }
    return () => {
      setIsEdit("");
      // UIUpdate();
      // localStorage.removeItem("archivedDesigns");
      // localStorage.removeItem("removedDesignsBySet");
    };
  }, [isEdit]);

  //useEffect for remove the updateProductsData
  useEffect(() => {
    if (!location?.state?.cataloguUpdate) {
      sessionStorage.removeItem("updateProductsData");
    }

    setIsEdit("archive");

    return () => {
      setSortOptions([]);
      setSelectedSortValue(null);
      setFilterCount(0);
      sessionStorage.setItem("filterChangeCount", 0);
      setAppliedFilterValues({});
      sessionStorage.removeItem("appliedSortValue");
      const goingToDesign = localStorage.getItem("navigatingToDesignPage") === "true";
      if (!goingToDesign) {
        setFilterValues({});
        setBackendFilterValues({});
        sessionStorage.removeItem("appliedFilterValues");
      }
    };
  }, []);

  const {
    data: sliderData,
    isLoading: isSliderDataLoading,
    isError,
  } = useQuery({
    queryKey: ["sliderData"],
    queryFn: async () => {
      const response = await apiClient.get(`/api/v1/set/getSetDesignSlidersData`);
      return response?.data?.data
    },
    staleTime: Infinity,
    refetchOnMount: false,
  });

  useEffect(() => {
    const fetchFilterData = async () => {
      try {
        if (sliderData) {
          const { diamondPieces, diamondWeight, grossWeight, netWeight, designQuantity, collectionName, categoryName } = sliderData;
          let filterData = {
            "Diamond Pieces": diamondPieces || [],
            "Diamond Weight": diamondWeight || [],
            "Gold Net-Weight": netWeight || [],
            Pieces: designQuantity || [],
            Collections: collectionName || [],
            Categories: categoryName || [],
            collectionName: [],
            piecesCount: [],
            categoriesName: [],
          };
          // Update the state with the fetched data
          setBackendFilterValues(filterData);

          if (sessionStorage.getItem("filterChangeCount") == 0) {
            setFilterValues(filterData);
          } else {
            const applied = JSON.parse(sessionStorage.getItem("appliedFilterValues"));
            setFilterValues((applied && Object.keys(applied).length > 0) ? applied : filterData);
          }
        }
      } catch (error) {
        console.error("Error fetching filter data:", error);
      }
    };

    // if (isEdit === "archive" || innerChnages) {
    fetchFilterData();
    // }
  }, [sliderData, location]);

  useEffect(() => {
    setSearch(location?.state?.setSearch || "");
  }, [location]);

  return (
    <>
      <RenderSets innerChnages={innerChnages} location={location} />
    </>
  );
};

export default Sets;
